import { OUTLOOK_BEAUTIFIED_PREFIX } from 'owa-attachment-link-common';

export function addBeautifiedPrefixToId(anchorElement: HTMLAnchorElement) {
    anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + anchorElement.id;
}
